import React, { useCallback } from 'react';
import { compose } from 'redux';
import { ListContainer } from '../../containers';
import { List } from '../../components';
import { useUserContext } from '../../../common/utils/context';
import ServiceRunFormMachineListItem from './ServiceRunFormMachineListItem';
import isListColumnVisible from '../../components/list/isListColumnVisible';

const ServiceRunFormMachineList = ({
	changeFormValue,
	values,
	header,
}) => {
	const { tenantSettings, tenant, userSettings } = useUserContext();

	const toggleMachine = useCallback(machine => {
		if (values.machines.includes(machine.id)) {
			changeFormValue({ machines: values.machines.filter(m => m !== machine.id) });
		}
		else {
			changeFormValue({ machines: [...values.machines, machine.id] });
		}
	}, [values.machines, changeFormValue]);

	const isMachineSelected = useCallback(machine => values.machines.includes(machine.id), [values.machines]);

	return (
		<List
			header={header}
			// The form header already sits under the page heading.
			removeTopMargin={Boolean(header)}
			showControls={true}
			customProps={{
				toggleMachine,
				isMachineSelected,
				tenantSettings,
				tenant,
			}}
			listItemComponent={ServiceRunFormMachineListItem}
			assembler={[
				{ label: 'ID', sortBy: 'assetId' },
				{ label: 'Location', sortBy: 'location' },
				// a bit hacky but Progressive Vending wanted the same list setting to control this and the web app list; obv could be improved in future
				...(isListColumnVisible(userSettings, 'sr_detail_machine_ms', { name: 'salesRestock' }) ? [{ label: '$ Sold', sortBy: 'salesSinceLastRestock' }] : []),
				{ label: 'Vendouts', sortBy: 'vendouts' },
				{ label: 'Vendouts prediction', sortBy: 'vendoutPredictionTomorrow' },
			]}
		/>
	);
};

export default compose(ListContainer)(ServiceRunFormMachineList);
